import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import ErrorImg from '../../../assets/errors/cloud.png';

export function NotFound() {
    return (
         <Fragment>
                <div className="d-flex flex-column align-items-center justify-content-center vh-100">
                    <img src={ErrorImg} alt="Error" style={{ maxWidth: 300 }} />
                    <p>404: Resource is not found.</p>
                    <Link to="/" className="text-primary">Main Page</Link>
                </div>
         </Fragment>
     );
}
